import React, { useState, useEffect, useContext } from 'react'
import { useParams } from "react-router-dom"
import PDFView from '../../components/PDFView'
import PDFEmbed from '../../components/PDFEmbed'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'

const Public = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext
    const { slug } = useParams()
    const [file, setFile] = useState('')
    const [viewWithIssuu, setViewWithIssuu] = useState(false)

    useEffect(() => {
        (async () => {
            setLoading(true)
            const authToken = props.location.search
            const response = await ApiService.getCatalogBySlug(slug, authToken)

            if (!response.data.success) {
                props.history.push(`/catalogos`)

                return false
            }

            const { catalog } = response.data
            if (catalog.viewWithIssuu) {
                setViewWithIssuu(catalog.viewWithIssuu)
                setFile(catalog.issuuUrl)
            } else {
                const baseUrl = `https://storage.googleapis.com/vendora-storage/catalogs/`
                setFile(`${baseUrl}${catalog.catalogFile}`)
            }
            setLoading(false)
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <React.Fragment>
            {file && viewWithIssuu && (
                <PDFEmbed url={`${file}`} />
            )}
            {file && !viewWithIssuu && (
                <PDFView url={`${file}`} />
            )}
        </React.Fragment>
    )
}

export default Public